import React, { useContext } from "react";
import {
  PortableText,
  PortableTextProps,
  PortableTextReactComponents
} from "@portabletext/react";
import { BlockContentPlaceholderResolverContext } from "./BlockContentComponentsProvider";

export type BlockContentValue = PortableTextProps["value"] | string | undefined;

export type UnstyledBlockContentProps = Omit<
  PortableTextProps,
  "value" | "components"
> & {
  value: BlockContentValue;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  tokens?: any;
};

export const UnstyledBlockContent: React.FC<
  React.PropsWithChildren<UnstyledBlockContentProps>
> = ({ value, tokens, ...props }) => {
  const placeholderResolverFunction = useContext(
    BlockContentPlaceholderResolverContext
  );

  if (!value) return null;
  if (typeof value == "string") return <React.Fragment>{value}</React.Fragment>;
  if (!Array.isArray(value))
    return <React.Fragment>{value.toString()}</React.Fragment>;

  let componentsWithPlaceholder:
    | Partial<PortableTextReactComponents>
    | undefined = undefined;

  if (tokens && placeholderResolverFunction) {
    componentsWithPlaceholder = {
      marks: {
        placeholder: ({ children }) => {
          const renderer = placeholderResolverFunction(tokens);
          return (
            <React.Fragment>{renderer(children as string[])}</React.Fragment>
          );
        }
      }
    };
  }

  return (
    <PortableText
      {...props}
      value={value}
      components={componentsWithPlaceholder}
    />
  );
};
